<template>
  <div>
    <div v-if="isLoading">
      <loading-svg-inline/>
    </div>
    <template v-else>
      <div class="flex flex-col space-y-4">
        <div v-for="(time, i) in times" :key="'time-' + i" class="border px-4 py-2 rounded-md | flex gap-x-2">
          <strong class="w-32 self-center">{{ mapDayOfWeekFromNumber(time.day).fr }}:</strong>
          <toggle-element v-model="time.isOpen" class="pr-4 " label="Ouvert"/>
          <div v-if="time.isOpen" class="flex gap-x-2">
            <time-picker-element v-model="time.openingTime" label="Héure de début"/>
            <time-picker-element v-model="time.closingTime" label="Héure de fin"/>
          </div>
        </div>
      </div>

      <div class="mt-8 | flex gap-x-4">
        <button-element type="primary" @click="saveTimes">
          <fa-icon class="mr-2" fixed-width icon="check"/>
          Sauvegarder
        </button-element>
        <button-element type="light" @click="cancelSave">
          Annuler
        </button-element>
      </div>
    </template>
  </div>
</template>

<script>
import {mapActions, mapGetters} from "vuex";
import {mapDayOfWeekFromNumber, mapEnglishDayToNumber} from "@/helpers/languageHelper";
import ToggleElement from "@/components/elements/toggles/ToggleElement.vue";
import TimePickerElement from "@/components/elements/forms/elements/base/TimePickerElement.vue";
import ButtonElement from "@/components/elements/buttons/ButtonElement.vue";
import LoadingSvgInline from "@/components/elements/loading/LoadingSvgInline.vue";

export default {
  name: "WoltManageVenueOpeningHoursEdit",
  components: {LoadingSvgInline, ButtonElement, TimePickerElement, ToggleElement},
  created() {
    this.getOpeningTimes.forEach(time => {
      const dayNumber = mapEnglishDayToNumber(time.opening_day);
      let foundTime = this.times.find(t => t.day === dayNumber);
      if (foundTime) {
        foundTime.openingTime = time.opening_time;
        foundTime.closingTime = time.closing_time;

        foundTime.isOpen = true;
      }
    })
  },
  data() {
    return {
      times: [
        {day: 1, openingTime: null, closingTime: null, isOpen: false},
        {day: 2, openingTime: null, closingTime: null, isOpen: false},
        {day: 3, openingTime: null, closingTime: null, isOpen: false},
        {day: 4, openingTime: null, closingTime: null, isOpen: false},
        {day: 5, openingTime: null, closingTime: null, isOpen: false},
        {day: 6, openingTime: null, closingTime: null, isOpen: false},
        {day: 7, openingTime: null, closingTime: null, isOpen: false},
      ],
      isLoading: false
    }
  },
  methods: {
    mapDayOfWeekFromNumber,
    mapEnglishDayToNumber,
    ...mapActions('wolt', [
      'fetchVenueStatus',
      'setVenueOpeningTimes',
    ]),
    cancelSave() {
      this.$emit('cancel');
    },
    saveTimes() {
      this.isLoading = true;

      this.setVenueOpeningTimes(this.getFormattedTimesForSaving).then(() => {
        this.$sendSuccessToast('Les heures d\'ouverture ont été enregistrées.');

        // For some reason, if you save and then immediately fetch, its not reflected
        // its like cached for a bit on Wolt. This is why I wait 2 seconds here
        // before refetching.
        setTimeout(() => {
          this.fetchVenueStatus().finally(() => {
            this.$nextTick(() => {
              this.isLoading = false;
              this.cancelSave();
            })
          });
        }, 2000);
      });
    }
  },
  computed: {
    ...mapGetters('wolt', [
      'getOpeningTimes'
    ]),
    getFormattedTimesForSaving() {
      return this.times.filter(t => t.isOpen).map(t => {
        const mappedDay = mapDayOfWeekFromNumber(t.day).en.toUpperCase();

        return {"opening_day": mappedDay, "closing_day": mappedDay, "opening_time": t.openingTime, "closing_time": t.closingTime};
      })
    }
  }
}
</script>